import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
	isSaveInProgress : false 
};

const saveDesignSlice = createSlice({
	name: 'saveDesign',
	initialState,
	reducers: {
		setSavingState(state, action: PayloadAction<boolean>) {
			state.isSaveInProgress = action.payload;
		},
	},
});

export const { setSavingState } = saveDesignSlice.actions;
export default saveDesignSlice.reducer;
